import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  root: {
    borderColor: mainColor.colorGray,
    backgroundColor: mainColor.colorWhite,
    overflow: 'hidden',
    elevation: 1
  },
  fab: {
    padding: 0.625,
    backgroundColor: `rgba(${mainColor.rgb}, 0.8)`,
    '&:hover': {
      backgroundColor: mainColor.secondaryColor
    }
  },
  description: {
    color: 'black'
  },
  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor
  },
  icon: {
    fontSize: UNIT * 1.5,
    margin: UNIT,
    color: mainColor.colorBlack
  },
  title: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight
  },
  row: {
    cursor: 'pointer'
  },
  form: { width: '100%' },
  panel: {
    height: UNIT * 4.125,
    width: '100%',
    borderBottomColor: mainColor.colorGray,
    borderWidth: 1
  },
  heading: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bolder',
    textAlign: 'center',
    color: mainColor.colorBlackLight,
    fontSize: UNIT * 0.9375,
    minWidth: UNIT * 14,
    flexBasis: '25%'
  },
  cell: {
    fontSize: UNIT * 0.9375,
    flexBasis: '25%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: UNIT * 14,
    flexShrink: 0,
    padding: UNIT * 0.625,
    textAlign: 'center',
    color: 'black !important'
  },
  choices: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  svg: { padding: UNIT * 0.625 }
});
